import { ClientIntegration, WebhookIntegrationData } from "@avenueops/shared-types";
import { SmartForm } from "@avenueops/web-components";
import CustomWebhookTabTypeHeader from "components/monitors/editFormReboot/CustomWebhookTabTypeHeader";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  notificationPrefix: string;
  disableCustomize?: boolean;
  webhookIntegrations?: ClientIntegration[];
}

export function WebhookNotificationInput({ notificationPrefix, disableCustomize, webhookIntegrations }: Props) {
  const {
    formState: { errors },
    control,
    watch,
  } = useFormContext();
  const selectedIntegrationId = watch(`${notificationPrefix}.integrationId`);

  const [showWebhookIntegrations, setShowWebhookIntegrations] = useState(
    (webhookIntegrations && webhookIntegrations?.length > 0 && selectedIntegrationId) ?? false
  );

  return webhookIntegrations && webhookIntegrations.length > 0 ? (
    <div className="col-span-4">
      <CustomWebhookTabTypeHeader showWebhookIntegrations={showWebhookIntegrations} setShowWebhookIntegrations={setShowWebhookIntegrations} />
      {showWebhookIntegrations ? (
        <div className="grid grid-cols-5 items-end gap-x-2">
          <div className="col-span-3">
            <SmartForm.DropdownSelect
              name={`${notificationPrefix}.integrationId`}
              options={webhookIntegrations.map((integration) => ({
                label: `${(integration.integrationData as WebhookIntegrationData).baseUrl} (${integration.name})`,
                value: integration.integrationId,
              }))}
            />
          </div>
          <div className="col-span-2">
            <SmartForm.TextInput name={`${notificationPrefix}.recipientValue`} placeholder="/optional-parameters" />
          </div>
        </div>
      ) : (
        <SmartForm.TextInput name={`${notificationPrefix}.recipientValue`} placeholder="https://example.com/my-webhook/" />
      )}
    </div>
  ) : (
    <div className="col-span-4">
      <SmartForm.TextInput
        name={`${notificationPrefix}.recipientValue`}
        title="Webhook to send a POST request to"
        placeholder="https://example.com/my-webhook/"
      />
    </div>
  );
}
